module.exports = __webpack_public_path__ + "static/media/bitbucket.8b9db395.png";